import React from 'react';

const Destination = () => {
    return (
        <div>
            <h2 style={{color: 'white', textAlign: 'center'}} >Will be add very soon...</h2>
        </div>
    );
};

export default Destination;